export const TOAST_ERROR_MESSAGE = 'Server error. Contact tech support for assistance.'
